var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimFlagInactiveMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Black-/-Inactive-Member",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round-person-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5857864,20 L5,20 C4.45,20 4,19.55 4,19 L4,18 C4,15.4685476 8.82729088,14.1325969 11.5951726,14.0093861 L2.29289322,4.70710678 C1.90236893,4.31658249 1.90236893,3.68341751 2.29289322,3.29289322 C2.68341751,2.90236893 3.31658249,2.90236893 3.70710678,3.29289322 L21.7071068,21.2928932 C22.0976311,21.6834175 22.0976311,22.3165825 21.7071068,22.7071068 C21.3165825,23.0976311 20.6834175,23.0976311 20.2928932,22.7071068 L17.5857864,20 Z M14.3552569,11.2339365 L8.76606349,5.64474314 C9.49331906,4.64763036 10.6706806,4 12,4 C14.21,4 16,5.79 16,8 C16,9.32931945 15.3523696,10.5066809 14.3552569,11.2339365 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimFlagInactiveMember);
export default __webpack_public_path__ + "static/media/claim-flag-inactive-member.f7a461142ffd9bbc62195145a91bdb26.svg";
export { ForwardRef as ReactComponent };